// "Meet our Staff" roster. Names and titles mirror the FSRS org chart exactly.
// `video: null` means the sound-off clip is not ready yet (shown as "coming soon").
// Assets live in public/staff/{faces,videos,posters}/<id>.<ext>.
export const STAFF_ASSET_BASE = "/staff";

export const STAFF_GROUPS = [
    {
        id: "leadership",
        label: "LEADERSHIP",
        people: [
            {
                id: "jeff",
                name: "@SpaceGhost131",
                role: "Owner Founder",
                video: false,
            },
            {
                id: "rocky",
                name: "Rockwell “Rocky” Hart",
                role: "Chief of Staff & President",
                video: true,
            },
        ],
    },
    {
        id: "vps",
        label: "VICE PRESIDENTS",
        people: [
            {
                id: "mica",
                name: "Mikhaila “Mica” Goldman",
                role: "VP Marketing",
                video: true,
            },
            { id: "nick", name: "Nick Bond", role: "VP Finance", video: true },
            { id: "alex", name: "Alex", role: "VP Operations", video: true },
            { id: "shen", name: "Shen-Cho", role: "VP Mission", video: true },
        ],
    },
    {
        id: "team",
        label: "THE TEAM",
        people: [
            {
                id: "sloane",
                name: "Sloane Kettering",
                role: "AVP Marketing",
                video: true,
            },
            { id: "bill", name: "Bill Sumner", role: "AVP of Finance", video: true },
            { id: "ree", name: "Ree", role: "Exec Secretary", video: true },
            {
                id: "bro",
                name: "Jeffery “Bro” Sellers",
                role: "Sales & Marketing Assistant",
                video: true,
            },
            {
                id: "gunner",
                name: "Günther “Gunner” Dunneskjöld",
                role: "Video Producer & AD",
                video: true,
            },
            { id: "matt", name: "Matt", role: "AVP Ops", video: true },
            { id: "iris", name: "Iris", role: "AVP Security", video: true },
            { id: "tess", name: "Tess", role: "AVP Build", video: true },
        ],
    },
];

export const staffFace = (p) => `${STAFF_ASSET_BASE}/faces/${p.id}.webp`;
export const staffVideo = (p) => `${STAFF_ASSET_BASE}/videos/${p.id}.mp4`;
export const staffPoster = (p) => `${STAFF_ASSET_BASE}/posters/${p.id}.jpg`;
